import React, { useState } from "react";
import logo from '../assets/Meevark.jpg'; // Tell webpack this JS file uses this image
import fb from '../assets/fb.svg'; // Tell webpack this JS file uses this image
import yt from '../assets/yt.webp'; // Tell webpack this JS file uses this image

import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
      <div className="container">
            <nav>
                <div className="logoAndButtons">
                    <Link to="/" className="title">
                        <img src={logo} alt="Logo" style={{height:100, width:192}}/>
                    </Link>
                    <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <ul className={menuOpen ? "open" : ""}>
                        <li className="link">
                        <NavLink to="/">Avaleht</NavLink>
                        </li>
                        <li className="link">
                        <NavLink to="/meist">Meist</NavLink>
                        </li>
                        <li className="link">
                        <NavLink to="/kontakt">Kontakt</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
            <ul className="socials">
                <li>
                <Link to="https://www.facebook.com/meevark">
                    <img src={fb} alt="Facebook" style={{height:51, width:51, paddingTop: 7}}/>
                </Link>
                </li>
                <li className="yt">
                <Link to="https://www.youtube.com/@Meev%C3%A4rk">
                    <img src={yt} alt="Youtube" style={{height:67, width:67}}/>
                </Link>
                </li>
            </ul>
        </div>
  );
};